<template>
  <div>
    <div
      class="modal animated fadeIn"
      id="fullfuel"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >Fuel Report</small
                >
              </legend>
              <form @submit.prevent="reportFuels()">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control from_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control end_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button
                      type="button"
                      class="btn btn-danger btn-flat"
                      data-dismiss="modal"
                    >
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingFullFuel"
                    >
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingFullFuelLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Manage fuel allocation</div>
            <fieldset class="border p-3">
              <button
                type="button"
                class="btn btn-success btn-roundec"
                data-toggle="modal"
                data-target="#fullfuel"
              >
                <i class="fa fa-file-pdf-o"></i> General Fuel
              </button>
              <p></p>
              <div></div>
              <div>
                <div class="fuelsLoader">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i
                    class="fa fa-spinner fa-spin"
                    style="font-size: 24px; color: blue"
                  ></i
                  >loading sales...
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="systemFuels"
                  :fixed-header="true"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 6,
                    position: 'bottom',
                    perPageDropdown: [3, 7, 9],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field === 'Action'">
                      <button
                        type="submit"
                        class="btn btn-primary btn-sm btn-rounded invoice_id"
                        @click="viewFuels(props.row.id)"
                      >
                        <i class="fa fa-print"></i>
                        Print
                      </button>
                    </span>
                  </template>
                </vue-good-table>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Ref no",
          field: "fuel_ref",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Fuel date",
          field: "fuel_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy",
          filterOptions: {
            enabled: true, // enable filter for this column
          }, // outputs Mar 16th 2018
        },
        {
          label: "Grand total",
          field: "grand_total",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Action",
          field: "Action",
          width: "100px",
          html: true,
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
      ],
    };
  },
  created() {
    this.loadFuel();
  },
  computed: {
    ...mapGetters(["systemFuels"]),
  },
  methods: {
    ...mapActions(["loadFuel", "viewFuels", "reportFuels"]),
  },
};
</script>
<style scoped>
.creatingFullFuelLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/fuels/managefuels.vue